import { Avatar, UserMenuHeaderButton } from '@hcs/design-system';

import { useAccount } from '../../hooks/useAccount';

import styles from './UserMenuAvatarButton.module.css';

interface UserMenuButtonsProps {
  className?: string;
}
const dataHcName = 'user-menu-avatar-button';
export const UserMenuAvatarButton = ({ className }: UserMenuButtonsProps) => {
  const { isSuccess, data: account } = useAccount();
  return (
    <UserMenuHeaderButton
      dataHcName={dataHcName}
      noCapture
      className={className}
      icon={
        <Avatar
          dataHcName={`${dataHcName}-avatar`}
          text={
            isSuccess
              ? `${account.user.firstName?.[0] || ''}${
                  account.user.lastName?.[0] || ''
                }`
              : ''
          }
        />
      }
      label={
        <div className={styles.Name}>
          <span data-hc-name={`${dataHcName}-first-name`}>
            {account?.user.firstName || ''}
          </span>
          {account?.user.firstName ? ' ' : ''}
          <span data-hc-name={`${dataHcName}-last-name`}>
            {account?.user.lastName || ''}
          </span>
        </div>
      }
      description={account?.organization.name || ''}
    />
  );
};
